import { Fragment, IDataFragment } from "core/components/FragmentProvider";
import { RowsView } from "common/views/rows/Rows.view";
import { ArticleContributor } from "../articleContributor/entities";

interface IArticleEditFragmentProps {
	articleContributor: ArticleContributor[];
	renderItem: (
		articleContributor: ArticleContributor,
		index?: number
	) => JSX.Element;
}

export const rows: Fragment<IArticleEditFragmentProps> = {
	name: "Rows",
	component: ({ articleContributor, renderItem }) => (
		<RowsView
			items={articleContributor}
			renderItem={renderItem}
			viewKey="articleContributorList.container.rows"
		/>
	),
};



// WEBPACK FOOTER //
// ./src/panels/articleDetails/article/parentContainerFragment.tsx